import React, { useState, useEffect } from "react";
import axios from "axios";
import { PayPalScriptProvider, PayPalButtons } from "@paypal/react-paypal-js";
import { MyContextSupply } from "../../Context";
import { ToastContainer, toast } from "react-toastify";
import ShippingAddress from "./Shipping/ShippingAddress";
import { Link, useNavigate } from "react-router-dom";

const Right = ({ item, totalPrice, totalItem }) => {
  const { cartItems, account, clearCart, token } = MyContextSupply();
  const navigate = useNavigate();
  const [isProceedToPay, setIsProceedToPay] = useState(false);
  const [shippingDetails, setShippingDetails] = useState({
    name: "",
    mobile: "",
    country: "",
    city: "",
    road: "",
    house: "",
    postalCode: "",
  });
  const [myAllDataForbackend, setMyAllDataForBackend] = useState("bal");
  const [bal, setBal] = useState({});
  const [run, setRun] = useState(false);
  const [isComplete, setIsComplete] = useState(false);
  // console.log(myAllDataForbackend);
  // console.log(bal);
  const { _id: userId } = account && account;
  const sendPaymentDataToBackend = async () => {
    await axios
      .post(
        "https://stechbackend-9r4c.onrender.com/purchase",
        {
          cartItems,
          shippingDetails,
          totalItem,
          totalPrice,
          userId,
          isComplete,
        },
        {
          headers: { Authorization: token },
          withCredentials: true,
        }
      )
      .then((res) => {
        if (res.status === 201) {
          // res.data.message
          // console.log(res.data);
          clearCart();
          navigate("/personalinfo");
          setIsComplete("not");
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const toggleRun = () => {
    setRun((previous) => !previous);
  };
  // this for collecting localStorage shipping address if available
  const localShippingData = localStorage.getItem("shippingAddress") || "";
  useEffect(() => {
    if (
      localShippingData !== null &&
      localShippingData !== undefined &&
      localShippingData !== ""
    ) {
      setShippingDetails(JSON.parse(localShippingData));
    } else {
      setShippingDetails({
        name: "",
        country: "",
        city: "",
        road: "",
        house: "",
        postalCode: "",
      });
    }
  }, [isProceedToPay]);
  useEffect(() => {
    if (isComplete === "completed") {
      sendPaymentDataToBackend();
    }
  }, [run]);
  return (
    <div className="right_buy">
      <ShippingAddress
        totalItem={totalItem}
        totalPrice={totalPrice}
        isProceedToPay={isProceedToPay}
        setIsProceedToPay={setIsProceedToPay}
        shippingDetails={shippingDetails}
        setShippingDetails={setShippingDetails}
        toggleRun={toggleRun}
        setBal={setBal}
        setIsComplete={setIsComplete}
      />
      <img
        src="https://cdn.nutrabay.com/wp-content/uploads/2017/09/100-Purchase-protection-at-nutrabay.png"
        alt="rightimg"
        style={{ padding: "10px", background: "white" }}
      />
      <div className="cost_right">
        <p>More than 600$ order is eligible for FREE Delivery.</p>
        <h2 style={{ marginTop: "5px" }}>Payment Info.</h2>
        <span style={{ color: "#565959" }}>
          Select this option at checkout. Details
        </span>
        <div>
          {account ? (
            <>
              <button
                onClick={() => setIsProceedToPay(true)}
                className="ProccedToPay_btn"
              >
                Proceed to Pay
              </button>
              <h3 className="subtotal_dis_buynow">
                Subtotal ({totalItem} item):
                <span style={{ fontWeight: 700 }}> ${totalPrice}</span>
              </h3>
            </>
          ) : (
            <>
              <Link to="/login">
                <button className="ProccedToPay_btn">Proceed to Pay</button>
              </Link>
              <h3 className="subtotal_dis_buynow">
                Subtotal ({totalItem} item):
                <span style={{ fontWeight: 700 }}> ${totalPrice}</span>
              </h3>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default Right;
